module.exports = __webpack_public_path__ + "static/media/Dead Island-01.8fa71624.svg";